import { profile } from '../../../../lib/apiList'
import axios from '../../../../lib/axios'
import { ChangePsswrd } from '../type'

export const changePassword = (data: ChangePsswrd): Promise<any> => {
    return axios.put(profile.CHANGEPASSWORD, data)
}
